import { gql } from '@lcs/shared/api';

export const getDashboards = gql`
   query GetDashboards($filters: String) {
      dashboardsConnection(filters: $filters) {
         items {
            name
            dashboardId
            userId
            lastSavedColumnLayoutSize
            dashboardTilesConnection {
               items {
                  dashboardTileId
                  tileViewMode
                  totalMillisecondsProcessed
                  totalTimesProcessed
                  tile {
                     tileId
                     name
                     description
                     typeId
                     canEditRefreshTime
                     isCustom
                     tileViewModeBound {
                        heightLowerBound
                        heightUpperBound
                        widthLowerBound
                        widthUpperBound
                     }
                  }
                  dashboardTileParametersConnection {
                     items {
                        parameterType
                        dashboardTileParameterId
                        dateRange {
                           relativeDate
                           relativeEndDate
                           relativeStartDate
                           startDate
                           endDate
                        }
                        entitiesToInclude {
                           all
                           entityIdsConnection {
                              items {
                                 entityId
                                 sortOrder
                              }
                           }
                           includeNull
                        }
                        valueBool
                        valueDateRangeParameterId
                        valueDateTime
                        valueEntitiesToIncludeId
                        valueNumeric
                        valueString
                     }
                  }
                  dashboardTileLayoutConfiguration {
                     dashboardTileLayoutConfigurationId
                     color
                     height
                     width
                     refreshTimeSeconds
                     maxHeight
                     minHeight
                     maxWidth
                     minWidth
                     name
                     column
                     row
                  }
                  dashboardTileParametersConnection {
                     items {
                        parameterType
                        dashboardTileParameterId
                        dateRange {
                           relativeDate
                           relativeEndDate
                           relativeStartDate
                           startDate
                           endDate
                        }
                        entitiesToInclude {
                           all
                           entityIdsConnection {
                              items {
                                 entityId
                                 sortOrder
                              }
                           }
                           includeNull
                        }
                        valueBool
                        valueDateRangeParameterId
                        valueDateTime
                        valueEntitiesToIncludeId
                        valueNumeric
                        valueString
                     }
                  }
               }
            }
         }
      }
   }
`;
